/**
 * Isolates react-helmet-async failures so a missing/mismatched Helmet context
 * cannot blank the page (ST-2026-150: helmetInstances.add on undefined).
 */
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from '../../utils/logger';
import { logClientErrorFromInnerBoundary } from '../../utils/reportClientIncident';

interface HelmetRenderErrorBoundaryProps {
  children: ReactNode;
}

interface HelmetRenderErrorBoundaryState {
  hasError: boolean;
}

class HelmetRenderErrorBoundary extends Component<HelmetRenderErrorBoundaryProps, HelmetRenderErrorBoundaryState> {
  constructor(props: HelmetRenderErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): HelmetRenderErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    logger.error('SEOHead Helmet render failed', error, {
      componentStack: errorInfo.componentStack,
    });
    logClientErrorFromInnerBoundary(error, 'HelmetRenderErrorBoundary', {
      component_stack: errorInfo.componentStack ?? undefined,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default HelmetRenderErrorBoundary;
